import { CircularLoader } from '@modules/common/components/CircularLoader';
import { TimePeriodUnit } from '@modules/common/components/DateRangePicker/types';
import { useNotificationContext } from '@modules/common/components/Notification/NotificationContext';
import { mapToEdgeTimeUnit } from '@modules/common/utils/mapToEdgeTimeUnit';
import { useFetchTenantBackfillDuration } from '@modules/users/hooks';
import { MenuItem, Select, SelectChangeEvent, Stack } from '@mui/material';
import { useUpdateTenantBackfillDurationMutation } from 'generated/graphql';
import { useState } from 'react';
import { useGetUser } from 'v2/core/services/user';

export const TaxonomyBackfillDurationSelect = () => {
  const { tenant } = useGetUser();
  const { duration, isLoading } = useFetchTenantBackfillDuration();
  const [durationValue, setDurationValue] = useState(duration?.value);
  const [updateBackfillDuration] = useUpdateTenantBackfillDurationMutation();
  const { showErrorNotification, showSuccessNotification } =
    useNotificationContext();

  const onChange = (event: SelectChangeEvent<number>) => {
    const selectedValue = Number(event.target.value);

    setDurationValue(selectedValue);
    updateBackfillDuration({
      variables: {
        id: tenant.id,
        dashboardSettings: {
          updateTenantBackfillSettingsInput: {
            tenantID: tenant.id,
            duration: {
              unit: mapToEdgeTimeUnit(TimePeriodUnit.Month),
              value: selectedValue,
            },
          },
        },
      },
      onError: () => {
        showErrorNotification({
          contentComponent: 'Failed to update backfill duration.',
          props: {},
        });
      },
      onCompleted: () => {
        showSuccessNotification({
          contentComponent: 'Successfully updated backfill duration.',
          props: {},
        });
      },
    });
  };

  return (
    <Stack width="200px" alignItems="center" justifyContent="center">
      {isLoading || !duration ? (
        <CircularLoader />
      ) : (
        <Select
          defaultValue={duration.value}
          value={durationValue}
          onChange={onChange}
          sx={{
            width: '100%',
          }}
          size="small"
        >
          <MenuItem value={1}>1 month</MenuItem>
          <MenuItem value={3}>3 months</MenuItem>
          <MenuItem value={6}>6 months</MenuItem>
          <MenuItem value={60}>All Time</MenuItem>
        </Select>
      )}
    </Stack>
  );
};
